import { LitterType } from "../models/LitterType";
import { useLitterTypes } from "./useLitterTypes";

const useLitterType = (id: LitterType["id"]): LitterType | null => useLitterTypes()?.find(lt => lt.id === id) ?? null;

export default useLitterType;
export { useLitterType };
